'use strict';
(function () {
    App.directive('variantsMatrixSingle', variantsMatrix);

    variantsMatrix.$inject = ['Config', 'variantsMatrixService'];

    function variantsMatrix(Config, variantsMatrixService) {
        return {
            restrict: 'E',
            scope: {
                lifePackages: "<",
                persons: '=',
                prices: '=',
                choose: '=',
                realDeclarationsNumber: '=?',
                isLifePackageHidden: "&?"
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/variants-matrix-single.html',
            link: function (scope) {
                scope.groupwidth = [];
                scope.singleLength = [];
                scope.allLength = 0;
                scope.singleItemGroupWeight = 2;
                scope.summary = 0;

                scope.checkPrice = function (price) {
                    scope.summary = price;
                };

                function initialize() {
                    variantsMatrixService.determineSingleAndAllLength(scope);
                    variantsMatrixService.determineGroupwidth(scope);
                }

                initialize();
                scope.$onChanges = function (change) {
                    if (change.lifePackages) {
                        initialize();
                    }
                };

                scope.isItemHidden = function(keyPerson, keyGroup, keyItem) {
                    if (scope.isLifePackageHidden) {
                        return scope.isLifePackageHidden()(keyPerson, keyGroup, keyItem);
                    }
                    return false;
                };
            }
        };
    }
})();
